import { render, staticRenderFns } from "./ProjectTeamUpdate.vue?vue&type=template&id=23bfdc1f&"
import script from "./ProjectTeamUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectTeamUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports